
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkyCol as SkyColElement } from '@sky.ui/core/sky-col';
 
 
 
 

 
 export const SkyCol = createComponent({
   displayName: 'SkyCol',
   react: React,
   tagName: 'sky-col',
   elementClass: SkyColElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-col';
